module.exports = __webpack_public_path__ + "static/media/UpperLimb2b8336bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/UpperLimb.svg
// module id = 1311
// module chunks = 0